import React, {Component} from 'react'
import { withRouter } from 'react-router'
import {positions, sectors, cuisines} from '../../Lists/lists'
import {findOption} from '../../Lib/findOption'
import moment from 'moment'
import {readableLocation} from '../../Lib/readableLocation'
import {fixHtml} from '../../Lib/fixHtml'
import Stars from '../../Components/Stars/Stars'
import FadingLine from '../../Components/FadingLine/FadingLine'
import { translate } from '../../Translations/translate'
import { connect } from 'react-redux'
import {ActionCreators} from '../../Actions'


class WorkExperience extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showMore: false
        }
    }
    render() {
        const { lang } = this.props.match.params
        let className = 'component_WorkExperience'
        if (this.props.className) {
            className += ' ' + this.props.className
        }
        
        let { item } = this.props

        let subtitle = []
        let sector = findOption(item.value.sector, sectors[lang])
        if (sector) { subtitle.push(sector) }
        let cuisine = findOption(item.value.cuisine, cuisines[lang])
        if (cuisine) { subtitle.push(cuisine) }
        let position = findOption(item.value.position, positions[lang])
        if (position) { subtitle.push(position) }

        let period = moment(item.value.fromYear + '-' + item.value.fromMonth + '-01', 'YYYY-M-DD').format('YYYY MMM') + ' - ' + (
            (item.value.currently)
            ? translate(lang, 'currently').toLowerCase()
            : moment(item.value.toYear + '-' + item.value.toMonth + '-01', 'YYYY-M-DD').format('YYYY MMM')
        )
        
        return (
            <div data-index={this.props.index} className={className}>
                <div className="col-group">
                    <div className="col-mb-6">
                        <div className="info">
                            <h5>
                                <div className="title">
                                    <div className="title-text">
                                        <span>{position}</span>
                                    </div>
                                </div>
                            </h5>
                            <span><FadingLine title={period} /></span>
                            <span><FadingLine title={readableLocation(item.value.location)} /></span>
                        </div>
                    </div>
                    <div className="col-mb-6">
                        <div className="info">
                            <h5>
                                <div className="title">
                                    <div className="title-text">
                                        {item.value.url ?
                                        <a href={item.value.url} target="_blank"><span>{item.value.company}</span></a>
                                        : <span>{item.value.company}</span>}
                                    </div>
                                </div>
                                <Stars number={item.value.rating} type={item.value.ratingtype !== undefined ? item.value.ratingtype : item.value.ratingType}/>
                            </h5>
                            <span><FadingLine title={cuisine} /></span>
                            <span><FadingLine title={sector} /></span>
                        </div>
                    </div>
                </div>
                {this.props.hideDescription ? null : this.renderDescription()}
                {this.props.btn ? <div className="col-group edit-btn"><div className="col-mb-12">{this.props.btn}</div></div> : null}
            </div>
        )
    }
    renderDescription() {
        const { lang } = this.props.match.params
        let {item} = this.props
        if (strip(item.value.description) === '') {
            return null
        }

        let { description } = item.value
        let teaser = !this.state.showMore && description && description.length > 120 ? description.substring(0, 120) + '...' : description
        let content = (
            <span>
                <span dangerouslySetInnerHTML={{__html: fixHtml(teaser)}}></span>
                <span>&nbsp;<span key="readMoreBtn" className="read-more" onClick={() => {this.setState({showMore: !this.state.showMore})}}>{this.state.showMore ? translate(lang, 'read_less') : translate(lang, 'read_more')}</span></span><br/>
            </span>
        )

        return (
            <div className="col-group description-wrapper">
                <div className="col-mb-12 the-description">
                    {content}
                </div>
            </div>
        )
    }
};

function strip(html)
{
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
}


const mapStateToProps = state => {
    return {    
    }
}
export default withRouter(connect(mapStateToProps, ActionCreators)(WorkExperience))